import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import authResources from './locales/authResources';

const syncDocumentDirection = (language?: string) => {
  if (typeof document === 'undefined') {
    return;
  }

  const nextLanguage = language ?? i18n.resolvedLanguage ?? i18n.language;
  document.documentElement.dir = i18n.dir(nextLanguage);

  if (nextLanguage) {
    document.documentElement.lang = nextLanguage;
  }
};

const reportMissingTranslationKey = (key: string): string => {
  // Do not crash end users; CI/static checks enforce key coverage.
  console.error(`[i18n] Missing translation key: ${key}`);
  return key;
};

const initPromise = i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'ar', 'fr'],
    resources: authResources,
    partialBundledLanguages: true,
    backend: {
      requestOptions: () => ({
        signal: AbortSignal.timeout(15_000),
      }),
    },
    ns: ['translation', 'auth'],
    defaultNS: 'translation',
    fallbackNS: 'auth',
    detection: {
      order: ['querystring', 'cookie', 'navigator', 'htmlTag'],
      caches: ['cookie', 'localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
    pluralSeparator: '_',
    returnNull: false,
    returnEmptyString: false,
    parseMissingKeyHandler: (key) => reportMissingTranslationKey(key),
  });

i18n.on('languageChanged', syncDocumentDirection);
syncDocumentDirection();
void initPromise.then(() => syncDocumentDirection());

export default i18n;
